export interface LanguageSelectUiState {
  open: boolean;
  query: string;
}

export const initialLanguageSelectUiState: LanguageSelectUiState = {
  open: false,
  query: "",
};

export type LanguageSelectUiAction =
  | { type: "toggle" }
  | { type: "open" }
  | { type: "close" }
  | { type: "setQuery"; query: string }
  | { type: "select" };

export function reduceLanguageSelectUi(
  state: LanguageSelectUiState,
  action: LanguageSelectUiAction,
): LanguageSelectUiState {
  switch (action.type) {
    case "toggle":
      return { ...state, open: !state.open };
    case "open":
      return { ...state, open: true };
    case "close":
      return { ...state, open: false, query: "" };
    case "setQuery":
      return { ...state, query: action.query };
    case "select":
      return { open: false, query: "" };
    default:
      return state;
  }
}

export function findLanguageLabel(
  options: readonly { code: string; label: string }[],
  value: string,
): string {
  return options.find((option) => option.code === value)?.label ?? value;
}
